@if (user) {
  <hawk-record-navigation
    class="app-page"
    [breadcrumbLinkList]="[
      { link: '/a/benutzer', description: 'Nutzer' },
      { link: '/a/benutzer/' + user.id, description: user.full_name },
    ]"
    [root]="'user'"
    [leafDescription]="'Bearbeiten'"
  >
    <div slot="toolbar" class="flex flex-row gap-2 items-center"></div>
    <div class="page-content px-4 pb-2 overflow-auto">
      <form [formGroup]="userForm" class="page-sheet max-w-7xl mx-auto" (submit)="onSubmit()">
        <div class="grid grid-flow-dense grid-cols-3">
          <div class="grid grid-flow-dense grid-cols-1">
            <fieldset class="bm-fieldset p-4 row-span-2">
              <legend class="bm-fieldset-legend text-lg">Stammdaten</legend>
              <ng-container [ngTemplateOutlet]="tplStammdaten" />
            </fieldset>
            <fieldset class="bm-fieldset p-4">
              <legend class="bm-fieldset-legend text-lg">Kontaktdaten</legend>
              <ng-container [ngTemplateOutlet]="tplKontaktdaten" />
            </fieldset>
          </div>
          <div class="grid grid-cols-2 col-span-2">
            <fieldset class="bm-fieldset p-4 relative">
              <legend class="bm-fieldset-legend text-lg">Adresse</legend>
              <div class="absolute -top-8 right-4 flex justify-end w-1/2 min-w-60" id="address_geocoder"></div>
              <ng-container [ngTemplateOutlet]="tplAdresse" />
            </fieldset>
            <fieldset class="bm-fieldset p-4 relative">
              <legend class="bm-fieldset-legend text-lg">Firmenadresse</legend>
              <div class="absolute -top-8 right-4 flex justify-end w-1/2 min-w-60" id="company_address_geocoder"></div>
              <ng-container [ngTemplateOutlet]="tplFirmenadresse" />
            </fieldset>
            <fieldset class="bm-fieldset p-4">
              <legend class="bm-fieldset-legend text-lg">Angestellt bei Subunternehmer</legend>
              <ng-container [ngTemplateOutlet]="tplSubunternehmer" />
            </fieldset>
            <fieldset
              class="bm-fieldset p-4"
              [class.row-span-2]="!hasDispatcherRole && !hasTechnicianRole"
              [class.row-span-3]="hasDispatcherRole !== hasTechnicianRole"
              [class.row-span-4]="hasDispatcherRole && hasTechnicianRole"
            >
              <legend class="bm-fieldset-legend text-lg">Nutzerrollen</legend>
              <ng-container [ngTemplateOutlet]="tplNutzerrollen" />
              @if (hasDispatcherRole) {
                <div class="border-t border-base-300 mt-3 pt-3">
                  <label class="bm-fieldset-label">Dispatcher-Farbe</label>
                  <app-color-picker
                    class="block mt-1"
                    [palette]="dispatcherColorPalette"
                    [value]="dispatcherColor"
                    placeholderColor="#4ECDC4"
                    emptyHint="Keine feste Farbe (Palette wird verwendet)"
                    (valueChange)="dispatcherColor = $event"
                  />
                </div>
              }
              @if (hasTechnicianRole) {
              <div class="border-t border-base-300 mt-3 pt-3">
                <label class="bm-fieldset-label">Tourfarbe (Dashboard und Planungsassistent)</label>
                <app-color-picker
                  class="block mt-1"
                  [palette]="tourColorPalette"
                  [value]="tourColor"
                  emptyHint="Keine feste Farbe (Palette wird verwendet)"
                  (valueChange)="tourColor = $event"
                />
              </div>
              }
            </fieldset>
            <fieldset class="bm-fieldset p-4">
              <legend class="bm-fieldset-legend text-lg">Sonstiges</legend>
              <ng-container [ngTemplateOutlet]="tplSonsiges" />
            </fieldset>
          </div>
        </div>

        <!-- Bestandsautomatik: nur für Techniker sinnvoll, alle anderen führen
             kein Material. Die Zeilen speichern sich direkt, nicht über das
             Formular — sie hängen am Nutzer, nicht an dessen Stammdaten. -->
        @if (hasTechnicianRole) {
          <fieldset class="bm-fieldset p-4 mt-4">
            <legend class="bm-fieldset-legend text-lg">Materialbestand</legend>
            <hawk-technician-stock-levels-grid
              [mode]="'technician'"
              [userId]="user.id"
              [addressState]="userForm.controls.state.value"
            />
          </fieldset>
        }

        @if (saveError) {
          <div class="bm-alert bm-alert-error bm-alert-soft mt-4">
            <i class="fa fa-info"></i>
            <span>{{ saveError }}</span>
          </div>
        }
        <div class="flex flex-row items-center justify-end gap-2 mt-4">
          <a [routerLink]="'/benutzer/' + user.id" class="bm-btn"> Abbrechen </a>
          <button class="bm-btn bm-btn-primary" [disabled]="!userForm.valid">Speichern</button>
        </div>
      </form>
    </div>
  </hawk-record-navigation>
}

<ng-template #tplStammdaten>
  <label class="bm-fieldset-label">Vorname</label>
  <input
    class="bm-input w-full"
    type="text"
    [formControl]="userForm.controls.first_name"
    [ngClass]="{ 'border-red-500': userForm.controls.first_name.invalid }"
  />

  <label class="bm-fieldset-label">Nachname</label>
  <input
    class="bm-input w-full"
    type="text"
    [formControl]="userForm.controls.last_name"
    [ngClass]="{ 'border-red-500': userForm.controls.last_name.invalid }"
  />

  <label class="bm-fieldset-label">E-Mail</label>
  <input
    class="bm-input w-full"
    type="text"
    [formControl]="userForm.controls.email1"
    [ngClass]="{ 'border-red-500': userForm.controls.email1.invalid }"
  />

  <label class="bm-fieldset-label">Zusätzliche E-Mail</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.email2" />
  <label>
    Nachrichten werden zusätzlich per CC an diese E-Mail-Adressen gesendet. Mehrere E-Mail können mit einem Semikolon
    getrennt angegeben werden.
  </label>

  <label class="bm-fieldset-label">E-Mail MoreApp</label>
  <input
    class="bm-input w-full"
    type="text"
    [formControl]="userForm.controls.email_moreapp"
    [ngClass]="{ 'border-red-500': userForm.controls.email_moreapp.invalid }"
  />
  <label>Diese E-Mail-Adresse wird für die Zuordnung in der MoreApp benutzt.</label>

  <label class="bm-fieldset-label">Partner E-Mail</label>
  <input
    class="bm-input w-full"
    type="text"
    [formControl]="userForm.controls.email_partner1"
    [ngClass]="{ 'border-red-500': userForm.controls.email_partner1.invalid }"
  />

  <label class="bm-fieldset-label">Zusätzliche Partner E-Mail</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.email_partner2" />
  <label>Mehrere E-Mail können mit einem Semikolon getrennt angegeben werden.</label>

  <label class="bm-fieldset-label">Kunde</label>
  <select class="bm-select w-full" [formControl]="userForm.controls.customer_id">
    <option value="">-Keine Zuordnung-</option>
    @for (customer of customers; track $index) {
      <option [value]="customer.id">{{ customer.name }}</option>
    }
  </select>

  <!-- <label class="bm-fieldset-label">Passwort</label>
  <input class="bm-input w-full" type="password" [formControl]="userForm.controls.password" /> -->
</ng-template>

<ng-template #tplKontaktdaten>
  <label class="bm-fieldset-label">Telefon (Beruflich)</label>
  <input
    class="bm-input w-full"
    type="text"
    [formControl]="userForm.controls.phone1"
    [ngClass]="{ 'border-red-500': userForm.controls.phone1.invalid }"
  />

  <label class="bm-fieldset-label">Telefon (Privat)</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.phone2" />

  <label class="bm-fieldset-label">Telefon für Dispatching</label>
  <input
    class="bm-input w-full"
    type="text"
    [formControl]="userForm.controls.telephone_dispatching"
    [ngClass]="{ 'border-red-500': userForm.controls.telephone_dispatching.invalid }"
  />
</ng-template>

<ng-template #tplAdresse>
  <label class="bm-fieldset-label">Firma</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.company" />

  <label class="bm-fieldset-label">Straße</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.street" />

  <label class="bm-fieldset-label">PLZ / Ort</label>
  <div class="flex flex-row gap-2">
    <input
      class="bm-input flex-1"
      type="text"
      [formControl]="userForm.controls.zip"
      [ngClass]="{ 'border-red-500': userForm.controls.zip.invalid }"
    />
    <input class="bm-input flex-2" type="text" [formControl]="userForm.controls.city" />
  </div>

  <label class="bm-fieldset-label">Land / Staat</label>
  <div class="flex flex-row gap-2">
    <input class="bm-input flex-1" type="text" [formControl]="userForm.controls.country" />
    <input class="bm-input flex-2" type="text" [formControl]="userForm.controls.state" />
  </div>
</ng-template>

<ng-template #tplFirmenadresse>
  <label class="bm-fieldset-label">Firma</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.company_address_company" />

  <label class="bm-fieldset-label">Straße</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.company_address_street" />

  <label class="bm-fieldset-label">PLZ / Ort</label>
  <div class="flex flex-row gap-2">
    <input
      class="bm-input flex-1"
      type="text"
      [formControl]="userForm.controls.company_address_zip"
      [ngClass]="{ 'border-red-500': userForm.controls.company_address_zip.invalid }"
    />
    <input class="bm-input flex-2" type="text" [formControl]="userForm.controls.company_address_city" />
  </div>

  <label class="bm-fieldset-label">Land / Staat</label>
  <div class="flex flex-row gap-2">
    <input class="bm-input flex-1" type="text" [formControl]="userForm.controls.company_address_country" />
    <input class="bm-input flex-2" type="text" [formControl]="userForm.controls.company_address_state" />
  </div>
</ng-template>

<ng-template #tplSubunternehmer>
  <label class="bm-fieldset-label">Angestellt bei Subunternehmer</label>
  <select class="bm-select w-full" [formControl]="userForm.controls.employer_id">
    <option value="">-</option>
    @for (subcontractor of subcontractors; track $index) {
      <option [value]="subcontractor.id">{{ subcontractor.name }}</option>
    }
  </select>
</ng-template>

<ng-template #tplNutzerrollen>
  <div class="flex flex-col gap-y-1">
    @for (checked_role of checkedRoles; track checked_role.role.id) {
      <label class="bm-fieldset-label">
        <input
          type="checkbox"
          class="bm-checkbox"
          [(ngModel)]="checked_role.checked"
          [ngModelOptions]="{ standalone: true }"
        />
        {{ checked_role.role.name }}
      </label>
    }
  </div>

  <div class="bm-divider my-2">App-Konfiguration</div>

  <div class="flex flex-col gap-y-1">
    <label class="bm-fieldset-label">
      <input
        type="checkbox"
        class="bm-checkbox"
        [(ngModel)]="appConfig.show_debug"
        [ngModelOptions]="{ standalone: true }"
      />
      Debug-Ausgaben anzeigen
    </label>

    <label class="bm-fieldset-label">
      <input
        type="checkbox"
        class="bm-checkbox"
        [(ngModel)]="appConfig.request_log_upload"
        [ngModelOptions]="{ standalone: true }"
      />
      Log-Upload anfordern
    </label>

    <label class="bm-fieldset-label cursor-pointer" [class.text-error]="appConfig.disable_checklist_validation">
      <input
        type="checkbox"
        class="bm-checkbox bm-checkbox-error"
        [(ngModel)]="appConfig.disable_checklist_validation"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onDisableChecklistValidationChange($event)"
      />
      <span class="font-bold">Checklisten-Validierung deaktivieren</span>
    </label>
    @if (appConfig.disable_checklist_validation) {
      <div class="bm-alert bm-alert-error text-sm">
        <span>
          <strong>ACHTUNG:</strong> Alle Prüf- und Sicherheitsmechanismen sind deaktiviert. Der Techniker kann ohne
          Validierung fortfahren. Bitte sofort wieder deaktivieren, sobald der fehlerhafte Auftrag abgeschlossen ist.
        </span>
      </div>
    }
  </div>
</ng-template>

<!-- Warndialog: Checklisten-Validierung deaktivieren -->
<dialog #checklistWarningDialog class="bm-modal">
  <div class="bm-modal-box max-w-lg">
    <h3 class="text-lg font-bold text-error">Checklisten-Validierung deaktivieren?</h3>
    <div class="py-4 flex flex-col gap-2">
      <p>
        Diese Einstellung deaktiviert <strong>alle Prüf- und Sicherheitsmechanismen</strong> in der Checkliste. Der
        Techniker kann ohne Validierung abschließen und potenziell fehlerhafte Daten übermitteln.
      </p>
      <p>
        <strong>Nur verwenden, wenn:</strong> Die Daten im Ticket-Interface bereits geprüft wurden, aber der Techniker
        den Auftrag in der App nicht abschließen kann.
      </p>
      <p class="text-error font-bold">
        Diese Einstellung muss sofort nach Abschluss des betroffenen Auftrags wieder deaktiviert werden!
      </p>
    </div>
    <div class="bm-modal-action">
      <button class="bm-btn" (click)="cancelDisableChecklistValidation()">Abbrechen</button>
      <button class="bm-btn bm-btn-error" (click)="confirmDisableChecklistValidation()">
        Verstanden, deaktivieren
      </button>
    </div>
  </div>
</dialog>

<ng-template #tplSonsiges>
  <label class="bm-fieldset-label">Versandfiliale (interner Materialversand)</label>
  <div class="bm-join w-full">
    <input
      class="bm-join-item bm-input w-full"
      type="text"
      readonly
      placeholder="-Keine Zuordnung-"
      [value]="internalShippingStoreName"
    />
    <button class="bm-join-item bm-btn" type="button" (click)="showStorePicker.set(true)">Wählen</button>
    @if (userForm.controls.internal_shipping_store_id.value) {
      <button class="bm-join-item bm-btn bm-btn-square" type="button" (click)="clearShippingStore()">✕</button>
    }
  </div>
  @if (missingInternalShippingStore) {
    <div class="bm-alert bm-alert-warning bm-alert-soft mt-1">
      <i class="fa fa-exclamation-triangle"></i>
      <span>Bentomax-Techniker sollten eine Versandfiliale zugeordnet bekommen.</span>
    </div>
  }

  <label class="bm-fieldset-label">Karten-Nr der Packstation</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.card_nr_packstation" />

  <label class="bm-fieldset-label">Pickpoint-Nr</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.pickpoint_nr" />

  <label class="bm-fieldset-label">XML-ID (für Ticket-Export)</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.xml_id" />

  <label class="bm-fieldset-label cursor-pointer mt-2">
    <input type="checkbox" class="bm-checkbox" [formControl]="userForm.controls.receives_return_tickets" />
    Bekommt Rückversandtickets
  </label>
  <label>
    Ist der Haken gesetzt, wird für nicht zurückgemeldetes Material automatisch ein Rückversandticket erzeugt und eine
    Retouren-Mail verschickt. Für Platzhalter-Benutzer bitte abwählen.
  </label>

  <!-- Instandsetzerkennzeichen fürs Eichamt (siehe bentomax/hawk#574) -->
  <label class="bm-fieldset-label">Instandsetzerkennzeichen</label>
  <input
    class="bm-input w-full"
    type="text"
    maxlength="60"
    placeholder="z. B. NW-1234"
    [formControl]="userForm.controls.verification_repairer_code"
  />
  <label>
    Kennzeichen dieses Technikers für die Reparatur-/Instandsetzungsmeldung ans Eichamt. Wird nach einem Eingriff in
    messtechnisch relevante Technik einer Waage gebraucht. Leer lassen, wenn der Techniker keines hat — es wird dann
    keines auf die Meldung gesetzt.
  </label>

  <label class="bm-fieldset-label">Notizen</label>
  <textarea class="bm-textarea w-full" [formControl]="userForm.controls.comment"></textarea>
</ng-template>

<!-- Filial-Picker für die Versandfiliale -->
@if (showStorePicker()) {
  <app-store-picker
    [projectIds]="[internalShippingProjectId]"
    [onlyUnassigned]="true"
    [alwaysIncludeStoreId]="userForm.controls.internal_shipping_store_id.value"
    [showAssignedUserColumn]="false"
    [passSearchAsCreateStoreName]="true"
    [initialSearch]="shippingStoreSearchPrefill"
    heading="Versandfiliale auswählen"
    (storeSelected)="onShippingStoreSelected($event)"
    (closed)="showStorePicker.set(false)"
  />
}
